<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M27 15H30" stroke="#18181B" stroke-linecap="round" />
    <path d="M27 22L29.7189 23.2679" stroke="#18181B" stroke-linecap="round" />
    <path d="M29.7189 7L27 8.26785" stroke="#18181B" stroke-linecap="round" />
    <path
      d="M22.627 4.82324C22.976 4.53574 23.4997 4.79485 23.5 5.2207V24.6904C23.5 25.1199 22.953 25.3927 22.5938 25.0889C21.2629 23.9632 19.3658 22.4705 17.8633 21.749C16.6952 21.1882 15.2653 20.6318 14.1357 20.2178C13.5695 20.0102 13.0755 19.8369 12.7227 19.7158C12.6406 19.6876 12.566 19.662 12.5 19.6396V10.3701C12.5607 10.3515 12.6285 10.3317 12.7021 10.3086C13.0528 10.1986 13.5454 10.039 14.1113 9.83984C15.2385 9.4431 16.6783 8.88362 17.8828 8.24121C19.2956 7.48765 21.2577 5.9518 22.627 4.82324Z"
      fill="#1DB6BD"
      stroke="#18181B"
      stroke-linejoin="round"
    />
    <path
      d="M7 10.5H12.5V19.5H7C6.17157 19.5 5.5 18.8284 5.5 18V12C5.5 11.1716 6.17157 10.5 7 10.5Z"
      stroke="#18181B"
    />
    <path
      d="M10.2158 19.5L11.9336 25.9414C12.1434 26.7281 11.5505 27.4999 10.7363 27.5C10.1749 27.5 9.68374 27.1225 9.53906 26.5801L7.65137 19.5H10.2158Z"
      fill="#1DB6BD"
      stroke="#18181B"
    />
    <path
      d="M5 12.5H5.5V17.5H5C3.61929 17.5 2.5 16.3807 2.5 15C2.5 13.6193 3.61929 12.5 5 12.5Z"
      stroke="#18181B"
    />
  </svg>
</template>

<script>
export default {
  name: 'Promoters',
}
</script>

<style lang="scss" scoped></style>
